import React from "react";
import "./App.css";
import Router from "./routes";
import ScrollToTop from "./hoc/ScrollToTop ";
import { ProductsProvider } from "./page/Products/productsProvider";
function App() {
  return (
    <ScrollToTop>
      <ProductsProvider>
      <Router />
      </ProductsProvider>
    </ScrollToTop>
  );
}

export default App;
